import { render, staticRenderFns } from "./OfertaSubastasIndex.vue?vue&type=template&id=388361a1"
import script from "./OfertaSubastasIndex.vue?vue&type=script&lang=js"
export * from "./OfertaSubastasIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports